import { api } from './client.js';

export const permissionsApi = {
  list: () => api.get('/admin/permissions', { query: { limit: 100 } })
};
